export enum DocumentTransferState {
  Unknow = -1,
  DoNotTransfer = 0,
  ToBeTransfered = 1,
  Transferring = 2,
  TransfertKO = 3,
  TransfertOK = 4,
}
